function showRegionToast(regionName) {
    if (regionName === 'us' || regionName === 'en-us') return; // ✅ Skip toast for US

  const toast = document.getElementById("region-toast");
  const regionText = document.getElementById("region-name");
  if (!toast || !regionText) {
  console.warn("⚠️ Toast elements not found in DOM.");
  return;
}


  if (toast && regionText) {
const regionLabels = {
  us: 'US Store',
  uk: 'UK Store',
  eu: 'EU Store',
  ca: 'Canada Store',
  'en-uk': 'UK Store',
  'en-us': 'US Store',       // 
  'en-ca': 'Canada Store',
};

    const label = regionLabels[regionName] || regionName.toUpperCase();
    regionText.textContent = `Switching to ${label}...`;

    toast.style.display = "block";
    toast.style.opacity = "1";

    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => {
        toast.style.display = "none";
        regionText.textContent = "";
      }, 500);
    }, 2000);
  }
}
if (window.location.pathname === '/book') {
  console.log('📚 /book redirect in progress — skipping custom.js logic');
  throw new Error('Stop custom.js for /book redirect');
}

if (
  window.location.pathname === '/pages/manage-subscriptions' ||
  window.location.pathname === '/pages/view-my-preorders' ||
  window.location.pathname === '/pages/manage-subscriptions-test'
) {
  console.log('🧾 Manage subscriptions page detected — skipping custom.js logic');
  throw new Error('Stop custom.js for manage subscriptions page');
}
  (async () => {
  if (localStorage.getItem('regionSelectedManually') === 'true') return;
    console.log('✅ Skipping IP-based redirect due to manual selection');

  try {
    const controller = new AbortController();
const timeoutId = setTimeout(() => controller.abort(), 2000);

const res = await fetch('https://ipapi.co/json', { signal: controller.signal });
clearTimeout(timeoutId);

    const data = await res.json();
    // data.country_code = 'SK'; // Simulate you're in the UK
let country = data.country_code; // ✅ use let, not const

const override = localStorage.getItem('regionDebugCountry');
if (override) {
  console.warn('🧪 Simulating country via override:', override);
  country = override;
}


    const EU_COUNTRIES = [
      'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
      'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
      'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
    ];

    let region = 'us'; // fallback

    if (country === 'GB') region = 'uk';
    else if (country === 'CA') region = 'ca';
    else if (EU_COUNTRIES.includes(country)) region = 'eu';

    // Redirect to correct subfolder if needed
    
    const regionPath = {
  us: '/en-us',  // US now subfolder
  uk: '/en-uk',
  ca: '/en-ca',
  eu: '',        // EU now root
      
};

const currentPath = window.location.pathname;
    const expectedPrefix = regionPath[region];
// Only redirect if not already in the correct region
//if (!currentPath.startsWith(expectedPrefix)) {
 // const cleanPath = currentPath.replace(/^\/(en-uk|en-us|en-ca)/, '');
 // sessionStorage.setItem('regionJustSwitched', region);
//  window.location.href = `${expectedPrefix}${cleanPath}`;
//}


  } catch (err) {
    console.warn('IP detection failed:', err);
  }
})();

document.addEventListener("DOMContentLoaded", async function () {
  if (window.BolderMatchaGuard?.active) return;
      sessionStorage.removeItem('suppressRegionRedirect'); // ✅ clear manual suppress flag
 sessionStorage.removeItem('regionJustSwitched');

const regionMap = {
  '/en-us': 46732331778273,    // US
  '/en-uk': 46732335481057 ,
  '/en-ca': 46732326502625,
  '/': 46732336791777,         // EU — put last
};



  const dummyHandles = {
    46732335481057: "dummy-uk",
    46732336791777: "dummy-eu",
    46732326502625: "dummy-ca",
    46732331778273: "dummy-us",
  };

  const pathname = window.location.pathname;
  let matchedRegion = "/"; // default to EU

  for (const prefix in regionMap) {
    if (pathname.startsWith(prefix)) {
      matchedRegion = prefix;
      break;
    }
  }
console.log("🧭 matchedRegion =", matchedRegion);
console.log("📍 pathname =", pathname);
// 🧭 Skip region redirect if manual /book redirect is in progress
if (sessionStorage.getItem('manual_region_redirect') === 'true') {
  console.log('⚡ Manual /book redirect detected — bypassing region correction');
  sessionStorage.removeItem('manual_region_redirect');
  return;
}
// debug region mismatch
const savedRegion = localStorage.getItem('selectedRegion');
const matchedPrefix = matchedRegion === '/' ? 'eu' : matchedRegion.replace('/en-', '').replace('/', '');
const manual = localStorage.getItem('regionSelectedManually') === 'true';

// Only auto-correct if the user didn't just switch manually
if (savedRegion && savedRegion !== matchedPrefix && !manual) {
  console.warn(`🛑 URL mismatch: savedRegion=${savedRegion} ≠ matched=${matchedPrefix} — redirecting`);

  showRegionToast(savedRegion);

  const targetPath = savedRegion === 'eu' ? '/' : `/en-${savedRegion}/`;
  window.location.href = targetPath + window.location.search + window.location.hash;
  return;
}
// debug region mismatch

  const dummyVariantId = regionMap[matchedRegion];
  const dummyHandle = dummyHandles[dummyVariantId];
  const regionKey = "jth_active_region";
  const previousRegion = sessionStorage.getItem(regionKey);
const regionLabel = document.getElementById('region-label');
const match = regionLabel?.textContent.match(/Ships from:\s*(\w+)/i);
const currentRegion = match ? match[1].toLowerCase() : 'eu';

// ✅ PREORDER INTAKE ISOLATION
const PREORDER_INTAKE_VARIANT_ID = 48229867716833;

try {
  const preorderCart = await fetch("/cart.js").then((res) => res.json());

  const hasPreorderIntake = preorderCart.items.some((item) => {
    return (
      Number(item.variant_id) === PREORDER_INTAKE_VARIANT_ID ||
      item.properties?._preorder === "true"
    );
  });

  const isCheckoutPage =
    window.location.pathname === "/checkout" ||
    window.location.pathname.includes("/checkouts");

  const isPreorderProductPage =
    Boolean(document.querySelector("[data-preorder-button]"));

  if (hasPreorderIntake && !isCheckoutPage && !isPreorderProductPage) {
    console.log("🧹 Preorder intake detected outside preorder flow — clearing cart");

    await fetch("/cart/clear.js", { method: "POST" });
    sessionStorage.removeItem("jth_preorder_active");

    window.location.reload();
    return;
  }
} catch (err) {
  console.warn("Preorder intake isolation failed:", err);
}

// ✅ FIRST VISIT (incognito/new user): behave like a region switch (toast + clear cart + reload)
// "First visit" = no savedRegion at all
if (!localStorage.getItem('selectedRegion') && !sessionStorage.getItem('first_visit_region_switch')) {
  sessionStorage.setItem('first_visit_region_switch', '1');

  // Save whatever region Shopify already routed them to
  localStorage.setItem('selectedRegion', currentRegion);

  // Show overlay
  const overlay = document.getElementById("region-overlay");
  if (overlay) {
    overlay.style.display = "block";
    overlay.offsetHeight; // force reflow
  }

  // Toast (same UX as your switch flow)
  showRegionToast(currentRegion);

  // Clear cart (same as region switch)
  await fetch("/cart/clear.js", { method: "POST" });
  await new Promise((r) => setTimeout(r, 300));

  // ✅ Ensure region-based inventory logic uses the correct region (not EU default)
await fetch("/cart/update.js", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ attributes: { region: currentRegion } }),
});

  // Establish baseline for this tab/session then reload
  sessionStorage.setItem(regionKey, currentRegion);

  setTimeout(() => {
    window.location.reload();
  }, 1000);

  return;
}

// ✅ NEW: If this tab has no previousRegion yet (new tab / browser reopen),
// initialize the session value and STOP.
// This prevents cart clear + reload on fresh open.
if (!previousRegion) {
  console.log("🧠 First load in this tab/session → set baseline region, do NOT clear/reload");
  sessionStorage.setItem(regionKey, currentRegion);
  return;
}

const regionChanged = previousRegion !== currentRegion;

  let cart = await fetch("/cart.js").then((res) => res.json());

  const cartRegion = cart.attributes?.region;
  const regionShort = dummyHandle.replace("dummy-", "");
console.log("🧩 dummyVariantId =", dummyVariantId);
console.log("🧩 dummyHandle =", dummyHandle);
console.log("📦 regionShort =", regionShort);

  if (cartRegion !== regionShort) {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { region: regionShort } }),
    });
  }  
// If region changed but no cart items, force reload to update liquid logic
  console.log("🧪 regionChanged:", regionChanged);
console.log("🧪 cart items:", cart.items.length);
console.log("🧪 regionJustSwitched?", sessionStorage.getItem('regionJustSwitched'));

if (!sessionStorage.getItem('regionJustSwitched') && regionChanged && cart.items.length === 0) {
  console.log("⚠️ Manual region change with empty cart → reloading for correct content");

  sessionStorage.setItem(regionKey, currentRegion);
  const overlay = document.getElementById("region-overlay");
  overlay.style.display = "block";

  // 🧠 Force reflow to ensure overlay applies immediately
  overlay.offsetHeight;

setTimeout(() => {
  showRegionToast(currentRegion);
}, 100);
//debug region mismatch
localStorage.setItem('selectedRegion', currentRegion);
localStorage.setItem('regionSelectedManually', 'true');
//debug region mismatch
  setTimeout(() => {
    window.location.reload();
  }, 1000);
}


 if (regionChanged && cart.items.length > 0) {
  // Show overlay
document.getElementById("region-overlay").style.display = "block";

// Show initial toast
showRegionToast(currentRegion); // ✅ this is already defined earlier

// Clear cart
await fetch("/cart/clear.js", { method: "POST" });
await new Promise((r) => setTimeout(r, 300));


  cart = await fetch("/cart.js").then((res) => res.json());
  sessionStorage.setItem(regionKey, currentRegion);
//debug region mismatch
localStorage.setItem('selectedRegion', currentRegion);
localStorage.setItem('regionSelectedManually', 'true');
//debug region mismatch
  setTimeout(() => {
    if (pathname !== matchedRegion + "/") {
      window.location.href =
  (matchedRegion === "/" ? "/" : matchedRegion + "/") +
  window.location.search +
  window.location.hash;
    } else {
      window.location.reload();
    }
  }, 1000); // match your existing delay
  } else {
    sessionStorage.setItem(regionKey, currentRegion);
  }


  
let bypassBuyNowInterceptor = false;

function bindBuyNowHandler(buyNowBtn) {
  buyNowBtn.dataset.bound = "true";

  buyNowBtn.addEventListener("click", async (e) => {
    if (bypassBuyNowInterceptor) {
      bypassBuyNowInterceptor = false;
      console.log("✅ Letting Buy It Now proceed");
      return;
    }

    e.preventDefault();
    console.log("🛑 Intercepted Buy It Now");

    buyNowBtn.disabled = true;
    buyNowBtn.style.pointerEvents = "none";
    buyNowBtn.style.opacity = 0.5;


    let attempts = 0;
    const maxAttempts = 10;

    const interval = setInterval(async () => {
      const done = await pollCart();
      attempts++;

      if (done || attempts >= maxAttempts) {
        clearInterval(interval);
        window.jthDummyInjecting = false;

        buyNowBtn.disabled = false;
        buyNowBtn.style.pointerEvents = "";
        buyNowBtn.style.opacity = "";

        bypassBuyNowInterceptor = true;
        console.log("🚀 Triggering Buy It Now");
        buyNowBtn.click();
      }
    }, 300);
  });
}
// ✅ Bulletproof version using MutationObserver
function runDummyCheckoutGuard() {
  const isDummy = (item) =>
    (item.sku && item.sku.toLowerCase().startsWith('dummy-')) ||
    /fulfil?lment routing/i.test(item.title) ||
    (item.properties && item.properties._d === 'true');

  async function updateCheckoutButtons() {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const hasItems = cart.items.length > 0;
      const hasReal = cart.items.some((i) => !isDummy(i));

      const btns = document.querySelectorAll(
        '[name="checkout"], .cart__checkout-button, button[data-checkout], a[href$="/checkout"]'
      );

      btns.forEach((btn) => {
        const noteId = 'dummy-only-warning';
        const existingNote = btn.parentElement?.querySelector('#' + noteId);

        if (hasItems && !hasReal) {
          btn.disabled = true;
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.6';

          if (!existingNote) {
            const note = document.createElement('div');
            note.id = noteId;
            note.textContent = 'Please add a product before checking out.';
            note.style.cssText = 'margin-top:8px;font-size:14px;color:#b00020;';
            btn.insertAdjacentElement('afterend', note);
          }
        } else {
          btn.disabled = false;
          btn.style.pointerEvents = '';
          btn.style.opacity = '';
          if (existingNote) existingNote.remove();
        }
      });
    } catch (err) {
      console.warn('🔁 Dummy guard failed:', err);
    }
  }

  // Re-check on these events
  document.addEventListener('cart:updated', updateCheckoutButtons);
  document.addEventListener('shopify:section:load', updateCheckoutButtons);

  // Observer to auto-run whenever cart UI changes
  const observer = new MutationObserver(updateCheckoutButtons);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Initial run
  updateCheckoutButtons();
}

// ⏳ Observe DOM for late-loaded Buy Now button
const observer = new MutationObserver(() => {
  const buyNowBtn = document.querySelector(".shopify-payment-button__button");
  if (!buyNowBtn || buyNowBtn.dataset.bound === "true") return;

  console.log("👀 Found Buy It Now button. Binding handler...");
  bindBuyNowHandler(buyNowBtn);
});
observer.observe(document.body, { childList: true, subtree: true });

// ⚡ Fallback if button already exists on page load
const existingBuyNowBtn = document.querySelector(".shopify-payment-button__button");
if (existingBuyNowBtn && !existingBuyNowBtn.dataset.bound) {
  console.log("⚡ Button already exists. Binding immediately...");
  bindBuyNowHandler(existingBuyNowBtn);
}




  document.querySelectorAll('.buy-it-now-btn').forEach(btn => {
  btn.addEventListener('click', async (e) => {
    e.preventDefault(); // stop default navigation

    // 🔥 Clear the Shopify cart
    await fetch('/cart/clear.js', { method: 'POST' });

    console.log('✅ Cart cleared. Ready to add items next...');
           // STEP 2: Add real + dummy product

    // 1️⃣ Try to read the CURRENTLY SELECTED variant from the product form
    const productForm =
      btn.closest('form[action^="/cart/add"]') ||
      document.querySelector('form[action^="/cart/add"]');

    let realVariantId = productForm?.querySelector('[name="id"]')?.value;

    // 2️⃣ Fallback: if for some reason we can't find it (e.g. quick-add card),
    //    use the data-variant-id from the button as a backup
    if (!realVariantId) {
      realVariantId = btn.getAttribute('data-variant-id');
    }

    console.log('🎯 Using variant for Buy It Now:', realVariantId);
    // dummyVariantId already defined above from regionMap — just use it directly here

    
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: realVariantId,
            quantity: 1,
          },
          {
            id: dummyVariantId,
            quantity: 1,
            properties: { _d: 'true', region: regionShort }
          }
        ]
      })
    });

    console.log('✅ Real and dummy products added to cart');

window.location.href = "/checkout";


  });
});

  // new way
document.body.addEventListener("click", function (e) {
  const target = e.target.closest("a[href*='/checkout'], button[name='checkout']");
  if (!target) return;

  e.preventDefault();

  (async () => {
    const cart = await fetch("/cart.js").then((res) => res.json());

    const hasDummy = cart.items.some(i =>
      i.title.toLowerCase().includes("fulfillment routing") &&
      i.properties?.region === regionShort
    );

    if (!hasDummy) {
      console.log("🧩 Injecting dummy before checkout...");

      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [
            {
              id: dummyVariantId,
              quantity: 1,
              properties: { region: regionShort }
            }
          ]
        })
      });

      await new Promise((r) => setTimeout(r, 500));
      console.log("✅ Dummy injected. Going to checkout...");
    } else {
      console.log("✅ Matching dummy already exists. Skipping injection.");
    }

    window.location.href = "/checkout";
  })();
});
runDummyCheckoutGuard();
}); // 👈 CLOSES the DOMContentLoaded function

(function () {
  function updateATCState() {
  const atcButton = document.querySelector(
    'product-form button[type="submit"]'
  );
  if (!atcButton) return;

  const variantContainer = document.querySelector('variant-selects');

  // ✅ No variants or only one variant → always allow ATC
  if (
    !variantContainer ||
    variantContainer.querySelectorAll('input[type="radio"]').length <= 1 &&
    !variantContainer.querySelector('select')
  ) {
   // atcButton.removeAttribute('disabled');
    atcButton.classList.remove('disabled');
    return;
  }

  const selected =
    variantContainer.querySelector('input[type="radio"]:checked') ||
    variantContainer.querySelector('select option:checked');

  if (!selected) {
    atcButton.setAttribute('disabled', 'disabled');
    return;
  }

  const isUnavailable =
    selected.disabled ||
    selected.classList.contains('variant--sold-out') ||
    selected.closest('.variant--sold-out');

  if (isUnavailable) {
    atcButton.setAttribute('disabled', 'disabled');
    atcButton.classList.add('disabled');
  } else {
    atcButton.removeAttribute('disabled');
    atcButton.classList.remove('disabled');
  }
}


  // Run on load
  document.addEventListener('DOMContentLoaded', updateATCState);

  // Run when variant changes
  document.addEventListener('change', (e) => {
    if (e.target.closest('variant-selects')) {
      updateATCState();
    }
  });
})();

(function () {
  function autoSwitchToAvailableVariant() {
    const variantContainer = document.querySelector('variant-selects');
    if (!variantContainer) return;

    // Current selection
    const selected =
      variantContainer.querySelector('input[type="radio"]:checked') ||
      variantContainer.querySelector('select option:checked');

    if (!selected) return;

    const isUnavailable =
      selected.disabled ||
      selected.classList.contains('variant--sold-out') ||
      selected.closest('.variant--sold-out');

    if (!isUnavailable) return;

    // Find first available radio
    const firstAvailableRadio = variantContainer.querySelector(
      'input[type="radio"]:not(:disabled)'
    );

    if (firstAvailableRadio) {
      firstAvailableRadio.checked = true;
      firstAvailableRadio.dispatchEvent(
        new Event('change', { bubbles: true })
      );
      return;
    }

    // Fallback for dropdowns
    const select = variantContainer.querySelector('select');
    if (select) {
      const option = Array.from(select.options).find((opt) => !opt.disabled);
      if (option) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', autoSwitchToAvailableVariant);

  // Run when variant changes
  document.addEventListener('change', (e) => {
    if (e.target.closest('variant-selects')) {
      autoSwitchToAvailableVariant();
    }
  });
})();
